'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconScreenCheckLinesCalendar, iconScreenCheckLinesCalendarTag } from '@ni/nimble-components/dist/esm/icons/screen-check-lines-calendar';
import { wrap } from '../../utilities/react-wrapper';

export type { IconScreenCheckLinesCalendar };
export { iconScreenCheckLinesCalendarTag };
export const NimbleIconScreenCheckLinesCalendar = wrap(IconScreenCheckLinesCalendar);